import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { filter } from 'rxjs/operators'
import { Observable, Subscription } from 'rxjs'

import { JwtService } from '@app/modules/auth/jwt.service'
import { AuthService } from '@app/modules/auth/auth.service'
import { AbstractSocketDirective } from '@app/modules/client/map/shared/abstractSocket.directive'
import { TrackerEventPayload, TrackerHistoryPayloadAsset } from '@app/modules/client/map/shared/models/tracker-history-payload.model'
import { ApiService } from '@shared/services/api.service'
import { NetworkStatusService } from '@core/services/network-status.service'
import { MapVehiclesService } from '@app/modules/client/map/map-details/vehicles/map-vehicles.service'
import { MapListVehiclesService } from '@app/modules/client/map/map-details/vehicles/map-list-vehicles.service'
import { DestroyService } from '@core/services/destroy.service'
import { MapApiService } from '@app/modules/client/map/map-api.service'
import { MapService } from '@app/modules/client/map/map.service'
import { io } from 'socket.io-client'
import { AssetRealtimeGateway } from '@core/services/realtime/asset-realtime.gateway'

@Injectable()
export class SocketAssetsService extends AbstractSocketDirective implements AssetRealtimeGateway {
  private assetIds: number[]
  private emitSubscribe: Subscription
  private coordinateObservable: Observable<TrackerHistoryPayloadAsset>
  private eventObservable: Observable<TrackerEventPayload>

  constructor(
    jwtService: JwtService,
    authService: AuthService,
    router: Router,
    apiService: ApiService,
    networkStatusService: NetworkStatusService,
    mapVehiclesService: MapVehiclesService,
    mapListVehiclesService: MapListVehiclesService,
    destroyService: DestroyService,
    mapApiService: MapApiService,
    mapService: MapService,
  ) {
    super(
      jwtService,
      authService,
      router,
      apiService,
      networkStatusService,
      mapVehiclesService,
      mapListVehiclesService,
      destroyService,
      mapApiService,
      mapService,
    )
  }

  connectToNamespace(): void {
    if (this.socket) return
    this.socket = io(`${this.baseUrlWS}/coordinatesByAsset`, this.defaultOptions)
  }

  subscribe(assetIds: number[]): void {
    this.isSocketExist()
    this.assetIds = assetIds

    this.emitSubscribe?.unsubscribe()
    this.emitSubscribe = this.socketState$.pipe(filter((s) => this.isConnected(s))).subscribe(() => {
      this.socket.emit('subscribeToAssets', { assetIds })
    })
  }

  getCoordinates(): Observable<TrackerHistoryPayloadAsset> {
    if (!this.coordinateObservable) {
      this.coordinateObservable = new Observable((observer): void => {
        const handleCoordinates = (coordinates: TrackerHistoryPayloadAsset) => observer.next(coordinates)
        const handleDisconnect = () => {
          observer.complete()
          this.coordinateObservable = null
        }

        this.socket.on('coordinatesByAsset', handleCoordinates)
        this.socket.on('disconnect', handleDisconnect)
      })
    }

    return this.coordinateObservable
  }

  getEvent(): Observable<TrackerEventPayload> {
    if (!this.eventObservable) {
      this.eventObservable = new Observable((observer): void => {
        const handleEvent = (event: TrackerEventPayload) => observer.next(event)
        const handleDisconnect = () => {
          observer.complete()
          this.coordinateObservable = null
        }

        this.socket.on('event', handleEvent)
        this.socket.on('disconnect', handleDisconnect)
      })
    }

    return this.eventObservable
  }
}
